export const DEV_ENV_STORAGE_KEY = 'vestigas_dev_env';

export const DEV_ENV_CONFIGS = {
  dev: {
    apiUrl: 'https://app.dev.vestigas.com/api/v1',
    contactPageUrl: 'https://contact.dev.vestigas.com',
    label: 'DEV',
    sgwUrl: 'https://sgw.dev.vestigas.com/db',
  },
  dev2: {
    apiUrl: 'https://app.dev2.vestigas.com/api/v1',
    contactPageUrl: 'https://contact.dev.vestigas.com',
    label: 'DEV2',
    sgwUrl: 'https://sgw.dev2.vestigas.com/db',
  },
  dev3: {
    apiUrl: 'https://app.dev3.vestigas.com/api/v1',
    contactPageUrl: 'https://contact.dev.vestigas.com',
    label: 'DEV3',
    sgwUrl: 'https://sgw.dev3.vestigas.com/db',
  },
  dev4: {
    apiUrl: 'https://app.dev4.vestigas.com/api/v1',
    contactPageUrl: 'https://contact.dev.vestigas.com',
    label: 'DEV4',
    sgwUrl: 'https://sgw.dev4.vestigas.com/db',
  },
  local: {
    apiUrl: 'http://localhost:8008/api/v1',
    contactPageUrl: 'http://localhost:8008/contact',
    label: 'LOCAL',
    sgwUrl: 'http://localhost:4984/db',
  },
  production: {
    apiUrl: 'https://app.vestigas.com/api/v1',
    contactPageUrl: 'https://contact.vestigas.com',
    label: 'PROD',
    sgwUrl: 'https://sgw.vestigas.com/db',
  },
  staging: {
    apiUrl: 'https://app.staging.vestigas.com/api/v1',
    contactPageUrl: 'https://contact.staging.vestigas.com',
    label: 'STAGING',
    sgwUrl: 'https://sgw.staging.vestigas.com/db',
  },
} as const;

export type DevEnvKey = keyof typeof DEV_ENV_CONFIGS;

const DEV_ENV_KEYS = Object.keys(DEV_ENV_CONFIGS) as DevEnvKey[];

function isValidDevEnvKey(key: string): key is DevEnvKey {
  return DEV_ENV_KEYS.includes(key as DevEnvKey);
}

function normalizeDevEnvKey(key: string): DevEnvKey | null {
  if (key === 'local-backend') {
    return 'local';
  }

  return isValidDevEnvKey(key) ? key : null;
}

export function getSelectedDevEnv(): DevEnvKey {
  const stored = sessionStorage.getItem(DEV_ENV_STORAGE_KEY);
  const envFromScript = import.meta.env.VITE_DEV_ENV as string | undefined;

  // A user selection made in the env switcher wins for the rest of the browser
  // session; the build-time VITE_DEV_ENV only provides the initial default
  // (e.g. a preview built from a branch ending in -dev4 starts on dev4).
  if (stored) {
    const normalized = normalizeDevEnvKey(stored);

    if (normalized) return normalized;
  }

  if (envFromScript) {
    const normalized = normalizeDevEnvKey(envFromScript);

    if (normalized) return normalized;
  }

  return 'dev';
}

export function switchDevEnv(key: DevEnvKey): void {
  sessionStorage.setItem(DEV_ENV_STORAGE_KEY, key);
  globalThis.location.reload();
}
